import { Suspense, useEffect } from 'react';
import '../index.css';
import Loader from '../components/LoaderComponent';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import One from '../components/HaloPromise/1';
import Two from '../components/HaloPromise/2';
import Three from '../components/HaloPromise/3';
import Four from '../components/HaloPromise/4';
import Five from '../components/HaloPromise/5';
import { useLocation } from 'react-router-dom';

// const LazyWhyChoose = React.lazy(() => import('../components/Home/WhyChoose'));
// const LazyVacationTypes = React.lazy(() => import('../components/Home/VacationTypes'));

const HaloPromise = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1));
        if (element) {
          const headerOffset = 100; // Adjust this value as needed
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100); // Small delay to ensure content is loaded
    }
  }, [location]);

  // const { data: hotels } = useQuery("fetchAllInclusiveHotels", apiClient.fetchHotels);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Halo Promise | Travel with Confidence | Halo Holidays</title>
          <meta name="description" content="The Halo Promise ensures your holiday is stress-free. Enjoy 24/7 support, flexible payments, and a price match guarantee. Book with Halo Holidays!" />
        </Helmet>
      </HelmetProvider>
      <section className="w-full my-4 mt-16 px-2 md:px-0">

        <div>
          <h1 className="text-3xl font-bold text-center mb-4 mt-4">Our Halo <span className='text-halo-pink'>Promise</span></h1>
        </div>

        <div className='border border-gray-200 p-6 my-8 rounded-md bg-white shadow-sm'>
          <div className='hidden md:block'>
            <h2 className="text-xl font-semibold mb-4">The Halo Promise Is More Than Just a <span className='text-halo-pink'>Guarantee</span></h2>
            <div className="space-y-4 mb-4">
              <p className="text-sm text-gray-600">Ready to book a holiday that goes above and beyond? Let's make it happen together. Explore our <span className='text-halo-pink'>All-Inclusive Holidays, Luxury Escapes, Family Packages</span>, and more, knowing that the Halo Promise has your back every step of the way.</p>
              <p className="text-sm text-gray-600">Here's to creating unforgettable memories with a team that truly cares. 🌞✨</p>
            </div>
          </div>
          <p className="text-sm text-gray-600 mb-4">Every point of our Halo Promise was created to help you travel with confidence, excitement, and joy. From the moment you book to the day you return home, our team is here to make your holiday everything you've imagined and more.</p>

          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex items-center">
              <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-4 h-4 mr-2" />
              <a href="#promise1" className="hover:text-halo-pink transition-colors underline">
                24/7 Toll-Free Holiday Hotline
              </a>
            </li>
            <li className="flex items-center">
              <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-4 h-4 mr-2" />
              <a href="#promise2" className="hover:text-halo-pink transition-colors underline">
                Easy Payment Plans
              </a>
            </li>
            <li className="flex items-center">
              <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-4 h-4 mr-2" />
              <a href="#promise3" className="hover:text-halo-pink transition-colors underline">
                96-Hour Free Fare Hold
              </a>
            </li>
            <li className="flex items-center">
              <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-4 h-4 mr-2" />
              <a href="#promise4" className="hover:text-halo-pink transition-colors underline">
                Flexible Accommodation Cancellation
              </a>
            </li>
            <li className="flex items-center">
              <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-4 h-4 mr-2" />
              <a href="#promise5" className="hover:text-halo-pink transition-colors underline">
                Price Match Guarantee
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-8">
          <div className="space-y-6">
            <Suspense fallback={<Loader />}>
              <One />
            </Suspense>
            <Suspense fallback={<Loader />}>
              <Two />
            </Suspense>
            <Suspense fallback={<Loader />}>
              <Three />
            </Suspense>
          </div>
          <div className="border border-gray-200 p-6 my-8 rounded-md bg-white shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center">
              <div className="w-full flex flex-col justify-center items-center md:items-start text-left">
                <h3 className="text-lg font-semibold mb-4 mt-4">
                  How the 96-Hour Free Fare Hold Works in 5 Easy Steps
                </h3>
                <ul className="pl-5 space-y-2 text-black text-sm">
                  <li>
                    <span className="font-medium text-black">1. Select Your Holiday</span> – Explore our holiday options, select your dates, and add your favorite trip to the cart.
                  </li>
                  <li>
                    <span className="font-medium text-black">2. Select Room Type & Meal Plan</span> – Select your perfect room and meal plan for a truly memorable stay.
                  </li>
                  <li>
                    <span className="font-medium text-black">3. Select Continue to View the Pricing Options</span> – After selecting your room and meal plan, click "Continue" to see the pricing options.
                  </li>
                  <li>
                    <span className="font-medium text-black">4. Select Option</span> – Select 'Reserve' from the pricing options to lock in this price for 96 hours while you finalize your plans.
                  </li>
                  <li>
                    <span className="font-medium text-black">5. Activate Your Free Hold</span> – Enter your details to secure today’s price for 96 hours at no cost, giving you peace of mind while you decide.
                  </li>
                </ul>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h3 className="text-lg font-semibold">Ready to Start Planning?</h3>
                  <p className="text-black mt-2">
                    Enjoy the flexibility to hold your fare for free while you finalize your plans, making your booking experience smooth, convenient, and pressure-free!
                  </p>
                </div>
              </div>
              <div className="w-full flex justify-center mt-6 md:mt-0">
                <img src="/general/96-1.png" alt="halo-promise" className="w-full md:w-9/12 h-auto" />
              </div>
            </div>
          </div>



          <div className="space-y-6">
            <Suspense fallback={<Loader />}>
              <Four />
            </Suspense>
          </div>

          <div className='border border-gray-200 p-6 my-8 rounded-md bg-white shadow-sm md:hidden'>
            <h2 className="text-xl font-semibold mb-4">The Halo Promise Is More Than Just a <span className='text-halo-pink'>Guarantee</span></h2>
            <div className="space-y-4">
              <p className="text-sm text-gray-600">Ready to book a holiday that goes above and beyond? Let's make it happen together. Explore our <span className='text-halo-pink'>All-Inclusive Holidays, Luxury Escapes, Family Packages</span>, and more, knowing that the Halo Promise has your back every step of the way.</p>
              <p className="text-sm text-gray-600">Here's to creating unforgettable memories with a team that truly cares. 🌞✨</p>
            </div>
          </div>

          <div className='border border-gray-200 p-4 mb-6 mt-6 rounded-md'>
            <h2 className="text-xl font-semibold mb-4">Stress-free holiday experience for everyone</h2>
            <p className="text-sm text-gray-600">A commitment designed to make your holiday planning easy, exciting, and absolutely worry-free! Here, we believe that every trip should feel like a dream from the very beginning, and our team is here to ensure just that. The Halo Promise isn’t just about guarantees; it’s about a brand-new way of holidaying, where you’re cared for like family, at every step of the journey. So, get ready to explore how we make it happen!</p>
          </div>

          <div className="space-y-6">
            <Suspense fallback={<Loader />}>
              <Five />
            </Suspense>
          </div>
        </div>

      </section>
    </>
  );
};

export default HaloPromise;
